import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * La asignación del faltante al responsable. Cuelga del mismo grupo aunque ocurra al día
 * siguiente: quien la usa es el jefe de operarios, que es quien tiene
 * `jornada.abrirCerrar`.
 */
export const rutaFaltantes = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/faltantes',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/faltantes/PaginaAsignarFaltante.js'),
    'PaginaAsignarFaltante'),
});
